import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchServiceBookingBp = createAsyncThunk(
    'service-booking/bp', 
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/service-booking/bp`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data.data.data;
        } catch (error) {
            console.error('Error fetch service booking bp:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const createServiceBookingBp = createAsyncThunk(
    'service-booking/bp/store', 
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.post(`${API_URL}/service-booking/bp/store`, items, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error store service booking bp:', error);
            return rejectWithValue(error.response?.data || 'Failed to store items');
        }
    }
);

export const updateStatusServiceBookingBp = createAsyncThunk(
    'service-booking/gr/update-status', 
    async (items, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.put(`${API_URL}/service-booking/update-status/${items.booking_id}`, items, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error update status service booking gr:', error);
            return rejectWithValue(error.response?.data || 'Failed to update status items');
        }
    }
);

const serviceBookingBp = createSlice({
    name: 'serviceBookingBp',
    initialState: {
        service_booking_bp: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchServiceBookingBp.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchServiceBookingBp.fulfilled, (state, action) => {
            state.isLoading = false;
            state.service_booking_bp = action.payload;
        })
        .addCase(fetchServiceBookingBp.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(createServiceBookingBp.fulfilled, (state, action) => {
            state.service_booking_bp.push(action.payload.ress.data);            
        })
        .addCase(updateStatusServiceBookingBp.fulfilled, (state, action) => {
            const index = state.service_booking_bp.findIndex((item) => item.booking_id === action.payload.data.booking_id);
            if (index !== -1) {
                state.service_booking_bp[index] = { ...state.service_booking_bp[index], ...action.payload.data };
            }
            state.isLoading = false;
        });
    },
});

export default serviceBookingBp.reducer;